import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { OAuthModule, OAuthStorage } from "angular-oauth2-oidc";

import { AppComponent } from "./app.component";

import { AppRoutingModule } from "./app-routing.module";
import { AccountModule } from "./account/account.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./core/core.module";
import { AuthenticationService } from "./services/authentication.service";
import { AuthGuardService } from "./guards/auth-guard.service";
import { AdminGuardService } from "./guards/admin-guard.service";
import { ConfigService } from "./services/config.service";
import { ProfileService } from "./services/profile.service";
import { environment } from "src/environments/environment";
import { SharedModule } from "./shared/shared.module";
import { RegistrationGuardService } from "./guards/register-guard.service";
import { ClientGuardService } from "./guards/client-guard.service";
import { ElevatedGuardService } from "./guards/elevated-guard.service";

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        AccountModule,
        CoreModule,
        SharedModule,
        OAuthModule.forRoot({
            resourceServer: {
                sendAccessToken: true,
                allowedUrls: environment.allowedUrls,
            },
        }),
        AppRoutingModule,
        BrowserAnimationsModule,
    ],
    declarations: [AppComponent],
    providers: [
        AuthenticationService,
        ConfigService,
        ProfileService,
        AuthGuardService,
        RegistrationGuardService,
        ElevatedGuardService,
        AdminGuardService,
        ClientGuardService,
        { provide: OAuthStorage, useValue: localStorage },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
